import { render, staticRenderFns } from "./CouponDrawer.vue?vue&type=template&id=c526f312&scoped=true&lang=pug&"
import script from "./CouponDrawer.vue?vue&type=script&lang=js&"
export * from "./CouponDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CouponDrawer.vue?vue&type=style&index=0&id=c526f312&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c526f312",
  null
  
)

/* custom blocks */
import block0 from "./CouponDrawer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports